import { isValidUrl } from "utils/urlUtils";
import { SDEContent } from "./sdecontentTypes";

export const AsyncUrls: SDEContent = {
  projectType: 'async_urls',
  projectCategory: 'async_urls',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/`;
  },
  docsSection: '',
  docsSectionTitle: '',
  docsSectionAsync: '',
  docsSectionAsyncTitle: '',
  inputKey: 'url',
  inputsKey: 'urls',
  validatorFunction: isValidUrl,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'URLs',
      listLiteralInputPlaceholder: 'Enter one URL per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: 'Input URLs',
      inputSectionDescription: "Enter URLs or upload a file",
    },
    projectContent: {
      title: 'Extract data from arbitrary websites',
      description: 'Download raw HTML from various URLs.',
      icon: 'urls',
      inputTitle: 'URL',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input URL address',
      inputSectionDescription: 'Enter the URL you want to scrape. The URL must be correctly encoded, like https://httpbin.org/json',
    },
    projectContent: {
      title: 'Data from URL',
      description: 'Create your request from any URL.',
      icon: 'urls',
    },
    enterInputsPlaceholder: 'https://httpbin.org/json',
    enterInputsMessage: 'Enter URL addresses for scraping',
    codeViewPlaceHolder: 'Please provide a valid URL',
    dropdownTitle: '', // This is not in the SDE selector dropdown
  }
};
